<script>
  export let time_modus;

  let left = [];
  let right_first_row = [];
  let right_second_row = [];
  let fourth_row = [];

  let left_monthly = [
    {
      text: "Monthly value",
      images: [
        "1a_Monthly value_line.png",
        "1b_Monthly value_stack.png",
        "1c_Monthly value_stack.png",
        "1d_Monthly value_3D area_stack.png",
      ],
    },
    { text: "Monthly value previous year", images: ["5a_Monthly value PY_line.png", "5b_Monthly value PY_stack.png"] },
    { text: "Yearly average previous year", images: ["5c_Yearly average PY.png"] },
    { text: "Average value (YTD or p.a.)", images: ["2_Average value.png"] },
    { text: "Target value", images: ["3_Target value.png"] },
    { text: "Month-to-month connection line", images: ["4_Month-to-month connection.png"] },
  ];

  let right_first_row_monthly = [
    { text: "Monthly revenue", images: ["1_Monthly revenue.png"] },
    { text: "Monthly costs", images: ["2_Monthly costs.png"] },
    { text: "Monthly EBITDA I", images: ["3_Monthly EBITDA I.png"] },
    { text: "Revenue p.m. previous year", images: ["4_Reveneu pm PY.png"] },
    { text: "Costs p.m. previous year", images: ["5_Costs pm PY.png"] },
    { text: "EBITDA I p.m. previous year", images: ["6_EBITDA I pm PY.png"] },
  ];

  let right_second_row_monthly = [
    { text: "Monthly value ", images: ["7_Monthly value line.png"] },
    { text: "Average value (YTD or p.a.)", images: ["8_Average value.png"] },
    { text: "Target value", images: ["9_Target value.png"] },
    { text: "Cow acquisition cost p.m.", images: ["10_Cow Acquisition cost pm stack.png"] },
  ];

  let left_quaterly = [
    { text: "Quarterly value", images: ["1a_Quarterly value_stack.png", "1b_Quarterly value_stack.png", "1c_Quarterly value_stack.png"] },
    { text: "Average value (YTD or p.a.)", images: ["2_Average value.png"] },
    { text: "Target value", images: ["3_Target value.png"] },
    { text: "Quarter-to-quarter connection line", images: ["4_Quarter-to-quarter connection.png"] },
    { text: "Quarterly value previous year", images: ["5_Quarterly value PY_stack.png"] },
    { text: "Yearly average previous year", images: ["6_Yearly average PY.png"] },
  ];

  let right_first_row_quaterly = [
    { text: "New leads per quarter", images: ["1_New leads pq_stack.png"] },
    { text: "New opportunities per quarter", images: ["2_New opps pq_stack.png"] },
    { text: "New customers per quarter", images: ["3_New customers pq_stack.png"] },
    { text: "Sold boluses per quarter", images: ["4_Sold_boli_pq.png"] },
    { text: "Quarterly value previous year", images: ["5_Quarterly value PY_stack.png"] },
  ];

  let right_second_row_quaterly = [
    { text: "Quarterly revenue", images: ["1_Quarterly revenue.png"] },
    { text: "Quarterly costs", images: ["2_Quarterly costs.png"] },
    { text: "Quarterly EBITDA I", images: ["3_Quarterly EBITDA I.png"] },
    { text: "Revenue p.q. previous year", images: ["4_Revenue pq PY.png"] },
    { text: "Costs p.q. previous year", images: ["5_Costs pq PY.png"] },
  ];

  let fourth_row_quaterly = [
    { text: "EBITDA I p.q. previous year", images: ["6_EBITDA I pq PY.png"] },
    { text: "Quarterly value", images: ["7a_Quarterly value_stack.png", "7b_Quarterly value_stack.png"] },
    { text: "Average value (YTD or p.a.)", images: ["8_Average value YTD oder pa.png"] },
    { text: "Average value prev. year", images: ["9_Average value PY.png"] },
    { text: "Target value", images: ["10_Target value.png"] },
  ];

  let left_biannual = [
    { text: "Half-year value", images: ["1a_Quarterly value_stack.png", "1b_Quarterly value_stack.png", "1c_Quarterly value_stack.png"] },
    { text: "Average value (YTD or p.a.)", images: ["2_Average value.png"] },
    { text: "Target value", images: ["3_Target value_line.png"] },
    { text: "Half-year value previous year", images: ["5_Quarterly value PY_stack.png"] },
    { text: "Yearly average previous year", images: ["6_Yearly average PY.png"] },
  ];
  let right_first_row_biannual = [
    { text: "New leads per half-year", images: ["1_New leads pq_stack.png"] },
    { text: "New opportunities per half-year", images: ["2_New opps pq_stack.png"] },
    { text: "New customers per half-year", images: ["3_New customers pq_stack.png"] },
    { text: "Sold boluses per half-year", images: ["4_Sold_boli_per_hy.png"] },
    { text: "Half-year value previous year", images: ["5_Quarterly value PY_stack.png"] },
  ];
  let right_second_row_biannual = [
    { text: "Half-year revenue", images: ["1_ HY Revenue_stack.png"] },
    { text: "Half-year costs", images: ["2_HY Costs_stack.png"] },
    { text: "Half-year EBITDA I", images: ["3_HY EBITDA I_stack.png"] },
    { text: "Half-year revenue/costs/EBITDA I p. half-yar previous year", images: ["4_HY rev-costs-ebitda I PY_stack.png"] },
  ];
  let fourth_row_biannual = [
    { text: "Half-year value", images: ["7a_Quarterly value_stack.png", "7b_Quarterly value_stack.png"] },
    { text: "Average value (YTD or p.a.)", images: ["8_Average value YTD oder pa.png"] },
    { text: "Average value prev. year", images: ["9_Average value PY.png"] },
    { text: "Target value", images: ["10_Target value.png"] },
  ];

  $: {
    time_modus;

    if (time_modus == "monthly") {
      left = left_monthly;
      right_first_row = right_first_row_monthly;
      right_second_row = right_second_row_monthly;
    }

    if (time_modus == "quaterly") {
      left = left_quaterly;
      right_first_row = right_first_row_quaterly;
      right_second_row = right_second_row_quaterly;
      fourth_row = fourth_row_quaterly;
    }

    if (time_modus == "biannual") {
      left = left_biannual;
      right_first_row = right_first_row_biannual;
      right_second_row = right_second_row_biannual;
      fourth_row = fourth_row_biannual;
    }
  }
</script>

<table style="margin-left: 7px;">
  <tr> <td colspan="5" style="padding-top:11px;"><b>Total active boluses, CLV, Churn rates:</b></td><td /></tr>
  <tr>
    {#each left as l}
      <td style="width: 50px; white-space:nowrap; padding-right:2px;">
        {#each l["images"] as image}
          <img
            class="funnel center-image"
            style="width:{image.includes('stack') ? 8 : 23}px; height:{image.includes('stack')
              ? 18
              : image.includes('line')
                ? 7
                : 2}px; margin: 1px;"
            src="/static/img/icons/{image}"
            alt="background image"
          />
        {/each}
      </td>
      <td style="white-space:nowrap; padding-right: 10px;">
        {l["text"]}
      </td>
    {/each}
  </tr>

  {#if time_modus == "monthly"}
    <tr> <td colspan="5" style="padding-top:11px;"><b>Revenue, costs, EBITDA</b> and<b> Conversion and Acquisition:</b></td><td /></tr>
  {/if}
  {#if time_modus == "quaterly" || time_modus == "biannual"}
    <tr> <td colspan="5" style="padding-top:11px;"><b>Status of sales funnel:</b></td><td /></tr>
  {/if}

  <tr>
    {#each right_first_row as l}
      <td style="width: 50px; white-space:nowrap; padding-right:2px;">
        {#each l["images"] as image}
          <img
            class="funnel center-image"
            style="width:{image.includes('stack') ? 8 : 23}px; height:{image.includes('stack')
              ? 18
              : image.includes('line')
                ? 7
                : 2}px; margin: 1px;"
            src="/static/img/icons/{image}"
            alt="background image"
          />
        {/each}
      </td>
      <td style="white-space:nowrap; padding-right: 10px;">
        {l["text"]}
      </td>
    {/each}
  </tr>

  {#if time_modus == "quaterly" || time_modus == "biannual"}
    <tr> <td colspan="5" style="padding-top:11px;"><b>Revenue, costs, EBITDA</b> and<b> Conversion and Acquisition:</b></td><td /></tr>
  {/if}

  <tr>
    {#each right_second_row as l}
      <td style="width: 50px; white-space:nowrap; padding-right:2px;">
        {#each l["images"] as image}
          <img
            class="funnel center-image"
            style="width:{image.includes('stack') ? 8 : 23}px; height:{image.includes('stack')
              ? 18
              : image.includes('line')
                ? 7
                : 2}px; margin: 1px;"
            src="/static/img/icons/{image}"
            alt="background image"
          />
        {/each}
      </td>
      <td style="white-space:nowrap; padding-right: 10px;">
        {l["text"]}
      </td>
    {/each}
  </tr>

  <tr>
    {#each fourth_row as l}
      <td style="width: 50px; white-space:nowrap; padding-right:2px;">
        {#each l["images"] as image}
          <img
            class="funnel center-image"
            style="width:{image.includes('stack') ? 8 : 23}px; height:{image.includes('stack')
              ? 18
              : image.includes('line')
                ? 7
                : 2}px; margin: 1px;"
            src="/static/img/icons/{image}"
            alt="background image"
          />
        {/each}
      </td>
      <td style="white-space:nowrap; padding-right: 10px;">
        {l["text"]}
      </td>
    {/each}
  </tr>
</table>

<style>
  td {
    font-size: 12px;
  }
</style>
